<template>
  <i class="mdi" :class="currentType"></i>
</template>
<script>
export default {
  name: "StockIconType",
  props: ["type"],
  computed: {
    currentType() {
      switch (this.type) {
        case 'defensive':
          return 'mdi-shield-outline';
        case 'cyclical':
          return 'mdi-rotate-3d';
        default:
          return 'mdi-comment-question-outline';
      }
    },
  },
};
</script>
<style scoped>
  i {
    color: white;
  }
</style>